import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import {
  Database,
  equalTo,
  listVal,
  orderByChild,
  query,
  ref,
  push,
  set,
  get,
} from "@angular/fire/database";
import {
  Observable,
  catchError,
  from,
  map,
  of,
  switchMap,
  throwError,
} from "rxjs";
import {
  IRemitente,
  IRemitenteDestinatario,
} from "../../../interfaces/catalogos.";
@Injectable({
  providedIn: "root",
})
export class RemitenteService {
  private database: Database = inject(Database);

  constructor(private http: HttpClient) {}

  cargarRemitentes(): Observable<IRemitenteDestinatario[]> {
    const refCatalogo = ref(this.database, "catalogos/remitente");
    const refQuery = query(refCatalogo, orderByChild("activo"), equalTo(true));
    return listVal(refQuery, { keyField: "id" }).pipe(
      map((remitentes: unknown[]) => {
        const remitentesTyped = remitentes as IRemitenteDestinatario[];
        return remitentesTyped.sort((a, b) => a.nombre.localeCompare(b.nombre));
      })
    );
  }

  async guardarRemitente(remitente: IRemitente): Promise<any> {
    const refCatalogo = ref(this.database, "catalogos/remitente");
    const nuevoRemitente = push(refCatalogo, {
      activo: true,
      nombre: remitente.nombre,
      apellido: remitente.apellido,
      mail: remitente.mail
    });

    return Promise.resolve({
      id: nuevoRemitente.key,
      ...remitente
    });

    /*const nuevoRemitenteRef = push(refCatalogo);
    const nuevoRemitente: IRemitenteDestinatario = {
      activo: true,
      nombre: remitente.nombre,
      apellido: remitente.apellido,
      id: nuevoRemitenteRef.key || "",
      mail: remitente.mail,
    };
    return set(nuevoRemitenteRef, nuevoRemitente);*/
  }

  editarRemitente(
    remitente: IRemitenteDestinatario
  ): Observable<{ error: boolean }> {
    const refRemitente = ref(
      this.database,
      `catalogos/remitente/${remitente.id}`
    );

    return from(get(refRemitente)).pipe(
      switchMap((remitenteSnapshot) => {
        if (remitenteSnapshot.exists()) {
          const editarRemitente = remitenteSnapshot.val();
          editarRemitente.nombre = remitente.nombre;
          editarRemitente.apellido = remitente.apellido;
          editarRemitente.mail = remitente.mail;

          return from(set(refRemitente, editarRemitente)).pipe(
            map(() => ({ error: false })),
            catchError(() => of({ error: true }))
          );
        } else {
          return throwError(() => new Error("El remitente no existe."));
        }
      }),
      catchError(() => of({ error: true }))
    );
  }

  eliminarRemitente(id: string): Observable<{ error: boolean }> {
    const refRemitente = ref(this.database, `catalogos/remitente/${id}`);

    return from(get(refRemitente)).pipe(
      switchMap((remitenteSnapshot) => {
        if (remitenteSnapshot.exists()) {
          const editarRemitente = remitenteSnapshot.val();
          editarRemitente.activo = false;
          return from(set(refRemitente, editarRemitente)).pipe(
            map(() => ({ error: false })),
            catchError(() => of({ error: true }))
          );
        } else {
          return throwError(() => new Error("El temitente no existe."));
        }
      }),
      catchError(() => of({ error: true }))
    );
  }
}
